module.exports = __webpack_public_path__ + "img/image_11.bbf40c1c.jpg";